import React, { createContext, useState } from "react";
import { useMemo } from "react";

export const OrgSiteGroupTreeContext = createContext({
  orgSelectedName: "",
  setOrgSelectedName: () => { },
  siteSelectedName: "",
  setSiteSelectedName: () => { },
  groupSelectedName: "",
  setGroupSelectedName: () => { },
});

export const OrgSiteGroupTreeContextProvider = ({ children }) => {
  const [orgSelectedName, setOrgSelectedName] = useState("");
  const [siteSelectedName, setSiteSelectedName] = useState("");
  const [groupSelectedName, setGroupSelectedName] = useState("");

  const contextValue = useMemo(() => {
    return {
      orgSelectedName,
      setOrgSelectedName,
      siteSelectedName,
      setSiteSelectedName,
      groupSelectedName,
      setGroupSelectedName,
    };
  }, [orgSelectedName, siteSelectedName, groupSelectedName]);

  return (
    <OrgSiteGroupTreeContext.Provider value={contextValue}>
      {children}
    </OrgSiteGroupTreeContext.Provider>
  );
};
